import React from 'react';
import { FullProject } from '../../../types';

export interface ProjectCategory {
  id: string;
  name: string;
  color: string;
  isCollapsed?: boolean;
}

export const CATEGORY_COLORS = [
  'bg-indigo-500', 'bg-violet-500', 'bg-purple-500', 'bg-fuchsia-500',
  'bg-rose-500', 'bg-orange-500', 'bg-amber-500', 'bg-emerald-500',
  'bg-teal-500', 'bg-cyan-500', 'bg-blue-500', 'bg-slate-500',
];

export const STORAGE_KEY_PREFIX = 'gwantt_categories_';

export const DARK_COLOR_MAP: Record<string, { text: string; border: string; bg: string; dot: string }> = {
  'bg-indigo-500': { text: 'text-indigo-400', border: 'border-indigo-500/25', bg: 'bg-indigo-500/15', dot: 'bg-indigo-400' },
  'bg-violet-500': { text: 'text-violet-400', border: 'border-violet-500/25', bg: 'bg-violet-500/15', dot: 'bg-violet-400' },
  'bg-purple-500': { text: 'text-purple-400', border: 'border-purple-500/25', bg: 'bg-purple-500/15', dot: 'bg-purple-400' },
  'bg-fuchsia-500': { text: 'text-fuchsia-400', border: 'border-fuchsia-500/25', bg: 'bg-fuchsia-500/15', dot: 'bg-fuchsia-400' },
  'bg-rose-500': { text: 'text-rose-400', border: 'border-rose-500/25', bg: 'bg-rose-500/15', dot: 'bg-rose-400' },
  'bg-orange-500': { text: 'text-orange-400', border: 'border-orange-500/25', bg: 'bg-orange-500/15', dot: 'bg-orange-400' },
  'bg-amber-500': { text: 'text-amber-400', border: 'border-amber-500/25', bg: 'bg-amber-500/15', dot: 'bg-amber-400' },
  'bg-emerald-500': { text: 'text-emerald-400', border: 'border-emerald-500/25', bg: 'bg-emerald-500/15', dot: 'bg-emerald-400' },
  'bg-teal-500': { text: 'text-teal-400', border: 'border-teal-500/25', bg: 'bg-teal-500/15', dot: 'bg-teal-400' },
  'bg-cyan-500': { text: 'text-cyan-400', border: 'border-cyan-500/25', bg: 'bg-cyan-500/15', dot: 'bg-cyan-400' },
  'bg-blue-500': { text: 'text-blue-400', border: 'border-blue-500/25', bg: 'bg-blue-500/15', dot: 'bg-blue-400' },
  'bg-slate-500': { text: 'text-slate-400', border: 'border-slate-500/25', bg: 'bg-slate-500/15', dot: 'bg-slate-400' }
};

export const getCategoryStyle = (color: string) => {
  return DARK_COLOR_MAP[color] || DARK_COLOR_MAP['bg-slate-500'];
};

export interface ProjectCardProps {
  project: FullProject;
  currentProjectId: string;
  onSelectProject: (id: string) => void;
  onClose: () => void;
  setIsDraggingProject: (isDragging: boolean) => void;
  setDragOverCategoryId: (id: string | null) => void;
  dragControls?: any;
}

export interface DrawerFolderItemProps {
  category: ProjectCategory;
  catProjects: FullProject[];
  isCollapsed: boolean;
  isDragOver: boolean;
  editingCategoryId: string | null;
  editingCategoryName: string;
  setEditingCategoryId: (id: string | null) => void;
  setEditingCategoryName: (name: string) => void;
  handleRenameCategory: (id: string) => void;
  handleDeleteCategory: (id: string) => void;
  handleChangeCategoryColor: (id: string, color: string) => void;
  toggleCategoryCollapsed: (id: string) => void;
  handleCategoryDragOver: (e: React.DragEvent, categoryId: string | null) => void;
  handleCategoryDrop: (e: React.DragEvent, categoryId: string | null) => void;
  setDragOverCategoryId: (id: string | null) => void;
  activeColorPickerId: string | null;
  setActiveColorPickerId: (id: string | null) => void;
  colorPickerRef: React.RefObject<HTMLDivElement | null>;
  editInputRef: React.RefObject<HTMLInputElement | null>;
  currentProjectId: string;
  onSelectProject: (id: string) => void;
  onClose: () => void;
  setIsDraggingProject: (isDragging: boolean) => void;
  onReorderProjects?: (newCatProjects: FullProject[]) => void;
}

export interface ProjectOverviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  projects: FullProject[];
  activeWorkspace: 'professional' | 'private';
  currentProjectId: string;
  onSelectProject: (id: string) => void;
  onUpdateProjectCategory: (projectId: string, categoryId: string | undefined) => void;
  globalMetadata?: any;
  onUpdateGlobalMetadata?: (updates: any) => void;
  onReorderProjects?: (newOrder: FullProject[]) => void;
}
